import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Leave() { 
  useEffect(() => {
    document.title = 'Leave -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Rules</li>
                <li>Leave</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Leave</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
               <ul className="mainlist">
                <li> A minimum attendance of 75% of the working days is required for promotion. Students should come in time for the general assembly. Late comers are liable to be sent home. </li>
                <li> No student should leave the School premises during the School hours without the written permission of the Principal granted on the written request of the parents. </li>
                <li> No leave of absence for the whole day or a part thereof is granted except for serious reasons and only on the previous written application of the parents or guardians. </li>
                <li> A student who is irregular to class due to festivals/ marriage celebrations/ trips/ visits to relations and places and frequent late comers will be asked to discontinue. </li>
                <li> Except for duly approved reasons extension of vacation is not permitted. Students who extend their holidays for more than seven days after vacation without sanction will have their names struck off the rolls. </li>
                <li> Application for medical leave for more than three days should be accompanied by a medical certificate by a MBBS doctor, If the leave continues for more than seven days/ the Principal must be intimated. </li>
                <li> All leave applications should bear the signature of the parents or in their absence the guardian. Failure to bring such an application for leave/ will make the students liable to be sent home. </li>
                <li> A student who is absent from the class continuously for ten days for more without the leave sanctioned by the Principal may have his name struck off the rolls without any notice. If re-admitted he/she will have to pay the full admission fee. </li>
                </ul> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Leave;
